import { doPost } from "./BaseAPI";

export function campaignTarget(target, start, end, number) {
  return doPost("/campaign/target", {
    target: target,
    start: start,
    end: end,
    number: number
  });
}